module.exports = __webpack_public_path__ + "media/images/faces/face2-4d873f5fa7f67effa9e0b555cd5cb907.jpg";